// TanStack Query hooks for the Account entity (reads).
//
// All orchestration lives in `services/AccountService/actions/`.
// This file is intentionally thin — TanStack wiring only.

import { useQuery } from '@tanstack/react-query';
import AccountService from '@/services/AccountService';
import { ACCOUNT_KEYS } from './keys';

/**
 * Foundation TanStack query for the current account + user identity.
 *
 * `staleTime: Infinity` — auth identity is session-static. The session-extend
 * keep-alive timer (driven inside `useAuth`) keeps the cookie alive; the
 * data here never needs background refetch.
 *
 * `retry: false` — auth probes fail fast (StrictMode safety is built-in:
 * concurrent renders dedupe to a single queryFn invocation per QueryClient).
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: ACCOUNT_KEYS.current(),
    queryFn: AccountService.fetchCurrentUser,
    staleTime: Infinity,
    retry: false,
  });
}
